import { render, staticRenderFns } from "./WidgetNews.vue?vue&type=template&id=4d51d6d4"
import script from "./WidgetNews.vue?vue&type=script&lang=js"
export * from "./WidgetNews.vue?vue&type=script&lang=js"
import style0 from "./WidgetNews.vue?vue&type=style&index=0&id=4d51d6d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports